import { nullable, object, record, string } from "../../../types/_types";

export const PipelineSettings = object({
	actions: record(
		string(),
		object({
			args: nullable(object().passthrough()),
			conditionalArgs: nullable(object().passthrough()),
		}),
	),
});
